const ZaloIcon = () => {
    return (<svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xmlSpace="preserve"
        viewBox="0 0 40 40"
    >
        <defs>
            <clipPath id="b">
                <path d="M0 0h40v40H0z" />
            </clipPath>
            <filter
                id="a"
                width="100%"
                height="100%"
                x="0%"
                y="0%"
                filterUnits="objectBoundingBox"
            >
                <feColorMatrix
                    in="SourceGraphic"
                    values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
                />
            </filter>
            <mask id="d">
                <g filter="url(#a)">
                    <path
                        d="M0 0h40v40H0z"
                        style={{
                            fill: "#000",
                            fillOpacity: 0.121569,
                            stroke: "none",
                        }}
                    />
                </g>
            </mask>
            <g id="c" clipPath="url(#b)">
                <path
                    d="M39.867 21.18v.578c0 4.855-.715 7.691-2.062 10.207-1.352 2.52-3.32 4.504-5.84 5.84-2.516 1.351-5.352 2.062-10.207 2.062h-3.516c-3.972 0-6.594-.476-8.793-1.39L5.82 34.742Zm0 0"
                    style={{
                        stroke: "none",
                        fillRule: "evenodd",
                        fill: "#001a33",
                        fillOpacity: 1,
                    }}
                />
            </g>
        </defs>
        <path
            d="M18.227.133h3.53c4.856 0 7.692.71 10.208 2.062 2.52 1.352 4.504 3.32 5.84 5.84 1.351 2.516 2.062 5.352 2.062 10.207v3.516c0 4.855-.71 7.691-2.062 10.207-1.352 2.52-3.32 4.504-5.84 5.84-2.516 1.351-5.352 2.062-10.207 2.062h-3.516c-4.855 0-7.691-.71-10.207-2.062-2.52-1.352-4.504-3.32-5.84-5.84C.844 29.449.133 26.613.133 21.758v-3.516c0-4.855.71-7.691 2.062-10.207 1.352-2.52 3.32-4.504 5.84-5.84C10.535.844 13.387.133 18.227.133Zm0 0"
            style={{
                stroke: "none",
                fillRule: "evenodd",
                fill: "#0068ff",
                fillOpacity: 1,
            }}
        />
        <use xlinkHref="#c" mask="url(#d)" />
        <path
            d="M6.223 34.871c1.859.207 4.183-.324 5.832-1.125 7.164 3.961 18.36 3.77 25.14-.566.262-.395.508-.805.735-1.23C39.285 29.421 40 26.573 40 21.706v-3.531c0-4.871-.715-7.719-2.07-10.246-1.34-2.528-3.332-4.504-5.86-5.86C29.543.715 26.695 0 21.828 0h-3.547c-4.148 0-6.843.523-9.105 1.52-.125.109-.246.222-.364.335-6.636 6.403-7.144 20.274-1.515 27.81.008.007.016.019.023.03.867 1.282.028 3.516-1.28 4.825-.212.199-.138.32.183.351Zm0 0"
            style={{
                stroke: "none",
                fillRule: "evenodd",
                fill: "#fff",
                fillOpacity: 1,
            }}
        />
        <path
            d="M16.45 13.602H8.671v1.668h5.398l-5.324 6.597c-.168.242-.289.469-.289.985v.425h7.34a.673.673 0 0 0 .668-.668v-.894h-5.672l5.004-6.281c.078-.09.215-.258.273-.332l.032-.047c.289-.422.347-.79.347-1.227ZM26.352 23.277h1.109v-9.675h-1.668v9.113a.56.56 0 0 0 .559.562ZM20.652 15.754a3.794 3.794 0 0 0-3.793 3.793c0 2.09 1.7 3.789 3.793 3.789 2.09 0 3.79-1.7 3.79-3.79.015-2.093-1.684-3.792-3.79-3.792Zm0 6.02c-1.23 0-2.23-1-2.23-2.227 0-1.23 1-2.23 2.23-2.23 1.227 0 2.227 1 2.227 2.23a2.22 2.22 0 0 1-2.227 2.226ZM32.39 15.691a3.828 3.828 0 0 0-3.824 3.825 3.827 3.827 0 0 0 3.825 3.82 3.826 3.826 0 0 0 3.82-3.82 3.827 3.827 0 0 0-3.82-3.825Zm0 6.082c-1.245 0-2.245-1-2.245-2.242 0-1.246 1-2.246 2.246-2.246 1.242 0 2.242 1 2.242 2.246 0 1.242-1 2.242-2.242 2.242Zm0 0"
            style={{
                stroke: "none",
                fillRule: "nonzero",
                fill: "#0068ff",
                fillOpacity: 1,
            }}
        />
        <path
            d="M23.566 23.277h.895v-7.312h-1.563v6.66c0 .348.301.652.668.652Zm0 0"
            style={{
                stroke: "none",
                fillRule: "nonzero",
                fill: "#0068ff",
                fillOpacity: 1,
            }}
        />
    </svg>)
}

export default ZaloIcon